import { useRef, useState } from "react";
import { Loader2, Upload } from "lucide-react";
import { toast } from "sonner";
import { errMsg, fileUrl, useAdminApi } from "@/lib/api";

export default function ImageInput({ value, onChange, testid }) {
  const req = useAdminApi();
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const r = await req("post", "/admin/upload", fd);
      onChange(r.path);
      toast.success("Image uploaded");
    } catch (er) { toast.error(errMsg(er)); } finally { setBusy(false); e.target.value = ""; }
  };
  return (
    <div className="flex items-center gap-3">
      {value ? <img src={fileUrl(value)} alt="" className="h-14 w-14 rounded-sm border border-white/10 object-cover" /> : <div className="h-14 w-14 rounded-sm border border-dashed border-white/20" />}
      <button type="button" onClick={() => ref.current?.click()} data-testid={testid} className="inline-flex items-center gap-2 rounded-full border border-white/20 px-4 py-2 text-xs font-bold uppercase tracking-wider hover:border-[#00E5FF]">
        {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Upload className="h-3.5 w-3.5" />}Upload
      </button>
      {value && <button type="button" onClick={() => onChange("")} className="text-xs text-slate-400 hover:text-red-300">Remove</button>}
      <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={pick} />
    </div>
  );
}
